import React, { useRef, useEffect, useLayoutEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { getViewportDimensions, getImageFilepath, getNavbarHeight } from '../../models/Utils';

import { Link, useParams } from 'react-router-dom';

import { ADAARIARoles, ADALandmarks, ADAWidgitRoles } from '../../models/ADA';
import './StoryArchive.scss';

const StoryArchive = props => {
  let { typeId } = useParams();
  const [ heightParams, setHeightParams ] = useState({ marginTop: 0, height: 0 });
  const dispatch = useDispatch();
  const initialized = useSelector(state => state.data.initialized);
  const cmsData = useSelector(state => state.data.cms.digitalMuseum);
  const dmnavbar = useSelector(state => state.data.menus.digitalMuseum);
  const mediaPath = useSelector(state => state.config.basePath + state.config.apiMediaPath);
  const menuOpened = useSelector(state => state.data.menuOpened);
  const [creditsActive, setCreditsActive] = useState(false);
  const creditsElement = useRef(null);
  const latestElement = useRef(null);
  const archiveElement = useRef(null);
  let [ada, setADA] = useState("");

  useEffect(() => {
    setTimeout(() => {
      setADANonRepeating(cmsData.StoryArchive.Menu.Text);
    }, 100);
  }, []);

  useEffect(() => {
    document.title = "The Verizon Story - Story Archive";
  }, [ada]);

  const handleScroll = () => {
    // if(creditsElement && creditsElement.current){
    //   const sliderRect = creditsElement.current.getBoundingClientRect();
    //   const windowHeight = getViewportDimensions().height;
    //   if ((sliderRect.y <= windowHeight)) {
    //     setCreditsActive(true);
    //   }
    //   else if ((sliderRect.y > windowHeight)) {
    //     setCreditsActive(false);
    //   }
    // }
  };

  const handleResize = () => {
    const marginTop = getNavbarHeight();
    setHeightParams({ marginTop });
  };

  const handleType = () => {
    setTimeout(() => {
      if (typeId === cmsData.StoryArchive.Subpaths.LatestStories) {
        document.body.scrollTo(0, 0);
      } else if (typeId === cmsData.StoryArchive.Subpaths.ArchivedStories) {
        document.body.scrollTo(0, archiveElement.current.getBoundingClientRect().top - latestElement.current.getBoundingClientRect().top);
      }
    }, 100);
  };

  useLayoutEffect(() => {
    // handleScroll();

    // document.body.addEventListener('scroll', handleScroll);
    // window.addEventListener('resize', handleScroll);

    // return () => {
    //   document.body.removeEventListener('scroll', handleScroll);
    //   window.removeEventListener('resize', handleScroll);
    // };
    handleResize();
    handleType();

    window.addEventListener('resize', handleResize);

    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, []);

  if(!initialized){
    return null;
  }

  function setADANonRepeating(text) {
    if (ada == text) return;
    setADA(text);
  }

  function generateStories(stories, columns) {
    const size = getViewportDimensions();
    const rowCount = Math.ceil(stories.length / columns);
    let rows = [];
    for (let i = 0; i < rowCount; i++) {
      const storiesInRow = stories.slice(i * columns, (i + 1) * columns);
      rows.push(
        <div className="cpvi-grid-row" key={i}>
          {
            storiesInRow.map((story, index) => {
              return (
                <div className={`cpvi-grid-col w${columns === 3 ? 4 : 6}`} key={index}>
                  <div className="sah-story-container">
                    <div className="sah-thumbnail-wrapper">
                      <div className="sah-thumbnail-inner">
                        <img
                          className="sah-thumbnail"
                          src={
                            mediaPath +
                            getImageFilepath(
                              story.StoryArchive.ThumbnailImage.Image || cmsData.Stories[0].StoryArchive.ThumbnailImage.Image,
                              size.width * 2
                            )
                          }
                          width={'100%'}
                          alt={story.StoryArchive.ThumbnailImage.AltText}
                        />
                      </div>
                    </div>
                    <h2 className="sah-description" role={ADAARIARoles.Heading}>{story.Header}</h2>
                    <Link to={`/${cmsData.Path.Text}/${story.Menu.Path}`} role={ADAWidgitRoles.Link}><button className="button-holder" tabIndex={-1} role={ADAARIARoles.Presentation}>{cmsData.StoryArchive.ButtonsLabel}</button><span className="sah-link-addition">: {story.Header}</span></Link>
                  </div>
                </div>
              );
            })
          }
        </div>
      );
    }
    return rows;
  }

  return (
    
    <div className="story-archive-home" role={ADALandmarks.Main}>
      {/* The div below is a hack for getNavbarHeight() to work */}
      <div className="exhibit-menu-container" style={{ height: 0 }}></div>
      <div style={{ height: `${heightParams.marginTop}px` }}></div>
      <div className="ada-hidden" aria-live="assertive">{ada}</div>
      <div role={ADAARIARoles.Region} aria-label={cmsData.StoryArchive.LatestStoriesLabel}>
        <div className="sah-header-container latest cpvi-grid-container" ref={latestElement}>
          <div className="cpvi-grid-row">
            <div className="cpvi-grid-col w12">
              <h1 className="sah-header">{cmsData.StoryArchive.LatestStoriesLabel}</h1>
            </div>
          </div>
        </div>
        <div className="sah-stories-container latest cpvi-grid-container">
          {generateStories(cmsData.Stories, 2)}
        </div>
      </div>
      <div role={ADAARIARoles.Region} aria-label={cmsData.StoryArchive.Menu.Text}>
        <div className="sah-header-container archive cpvi-grid-container" ref={archiveElement}>
          <div className="cpvi-grid-row">
            <div className="cpvi-grid-col w12">
              <h1 className="sah-header">{cmsData.StoryArchive.Menu.Text}</h1>
            </div>
          </div>
        </div>
        <div className="sah-stories-container archive cpvi-grid-container">
          {generateStories(cmsData.ArchivedStories, 3)}
        </div>
      </div>
    </div>
  );
};

export default StoryArchive;
